import React from 'react'

import './loader.css'

const Loader = () => {
  return (
    <div className="round-loader">
      <div className="loader"></div>
    </div>
  )
}

export default Loader